export class Reason {
  id: bigint;
  name: string;
  type_id: number;
  description: string;
  text: string;
  color: string;
  order: number;
  active: number;
}
